module.exports = __webpack_public_path__ + "static/product2_4-45544ca3379b1ab0a23942ba427536f6.jpg";